import * as CommunicationDispositionStatus from 'src/constants/communication-disposition-status'
import * as CommunicationCurrentStatus from 'src/constants/communication-current-status'

export default {
  data: () => ({
    incomingCallNotificationStatuses: [
      CommunicationCurrentStatus.CURRENT_STATUS_RINGING_NEW,
      CommunicationCurrentStatus.CURRENT_STATUS_QUEUED_NEW,
      CommunicationCurrentStatus.CURRENT_STATUS_RINGALL_NEW
    ]
  }),

  methods: {
    isCallNotInProgressOrIncoming (commDispStatus, commCurrStatus) {
      return commDispStatus !== CommunicationDispositionStatus.DISPOSITION_STATUS_INPROGRESS_NEW ||
        !this.incomingCallNotificationStatuses.includes(commCurrStatus)
    }
  }
}
